<template>
  <v-container
    class="fill-height"    
    fluid
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        md="4"
      >
        <material-card
          color="green"
          title="Login"
        >
          <v-form        
            ref="form"
            lazy-validation
          >
            <v-container class="py-0">
              <v-row>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="username"
                    :rules="[rules.required]"
                    :disabled="progressing"                    
                    prepend-icon="person"
                    label="User Name"
                    type="text"
                    class="purple-input"
                    autofocus
                  />
                  <v-text-field
                    v-model="password"
                    :rules="[rules.required]"
                    :disabled="progressing"
                    prepend-icon="lock"                      
                    label="Password"
                    type="password"
                    class="purple-input"
                    @keydown.enter="login"
                  />                 
                </v-col>
                <v-col
                  class="text-right"
                  cols="12"
                >
                  <v-btn           
                    :loading="progressing"         
                    class="mx-0 font-weight-light"                    
                    color="success"
                    @click="login"                    
                  >
                    LETS GO
                  </v-btn>
                  <v-snackbar                    
                    v-model="snackbar"
                    :color="snackbarColor"
                    :top="true"                                       
                    dark                    
                  >
                    <v-icon
                      color="white"
                      class="mr-4"
                    >
                      mdi-bell-plus
                    </v-icon>
                    <div align="left">
                      {{ errorMessages }}
                    </div>
                    <v-icon
                      size="16"
                      @click="snackbar = false"
                    >
                      mdi-close-circle
                    </v-icon>
                  </v-snackbar>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </material-card>
      </v-col>
      <v-col
        v-if="lock"
        cols="12"
        md="12"
      >
        <v-card
          class="mx-auto"
          max-width="600"
        >
          <div class="pa-4 text-center text-danger">
            Unable to connect to server! Please contact your administrator quoting the following error code: 
          </div>
        
          <div class="display-4 pa-4 text-center text-danger">
            {{ code }}
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapActions } from 'vuex'
  export default {
    data: () => ({
      username: '',
      password: '',

      progressing: false,

      snackbar: false,
      snackbarColor: 'error',
      errorMessages: 'Please try again',

      browser: null,
      os: null,
      components: [],
      lock: false,
      code: '',
      url: 'hrm.trinitysearch.net',
 
      rules: {
        required: value => !!value || 'Required.',
      },
    }),
    created () {
      let _this = this

      let parser = new window.UAParser()
      let userAgent = parser.getResult()

      if (this.getCookie('device_id') === '') {
        let hostname = window.location.hostname.split('.')
        let cookie = 'device_id=' + this.uuidv4() + ';expires=Thu, 18 Dec 2025 12:00:00 UTC;' + (hostname.length === 3 ? 'domain=' + hostname[1] + '.' + hostname[2] : '')
        document.cookie = cookie
      }

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          _this.latlong = position.coords.latitude + ',' + position.coords.longitude
        })
      }

      let options = {
        extraComponents: [
          {
            key: 'deviceID',
            getData: function (done) {
              done(_this.getCookie('device_id'))
            },
          },
        ],
      }
    
      this.browser = userAgent.browser.name + ' ' + userAgent.browser.version
      this.os = userAgent.os.name + ' ' + userAgent.os.version

      window.Fingerprint2.get(options, function (components) {
        components.forEach((val) => {
          _this.components.push(val.key + ': ' + val.value)
        })

        _this.hash = window.Fingerprint2.x64hash128(components.map(function (pair) { return pair.value }).join(), 31)
      })
    },

    methods: {
      ...mapActions('lookup', ['getLookups']),
      setProgressing (value = false) {
        this.progressing = value
      },
      validate () {
        return this.$refs.form.validate()
      },
      login: function () {
        if (!this.validate()) return

        this.setProgressing(true)

        let username = this.username 
        let password = this.password
        let browser = this.browser
        let os = this.os
        let hash = this.hash
        let components = this.components
        let latlong = this.latlong
        let url = this.url

        this.$store.dispatch('login', { username, password, browser, os, hash, components, latlong, url })
          .then((response) => {
            this.loadData()   
              .then(data => {              
                this.$router.push({ path: '/profile' })    
              })
              .catch(() => {
                this.$manualLogout()
              })
              .then(() => {
                this.setProgressing(false)   
              })
          })
          .catch(err => {
            let response = err.response

            if ((response.data || {}).message) {
              this.errorMessages = (response.data || {}).message
            } 

            if (response.data.message.includes('Unable to connect to server')) {
              this.code = response.data.message.substring(
                response.data.message.lastIndexOf(':') + 1,
              )
              this.lock = true
            } else {
              this.snackbar = true 
            }
          
            this.setProgressing(false)       
          })
      },
      loadData () {
        // let username = this.username

        return this.$http.all([
          this.$store.dispatch('getCurrentUser'),
          this.$store.dispatch('getUserPermissions'),
          // this.$store.dispatch('updateUserLastLogin', { username }), // comment until lms classic no more in used
          this.getLookups('title'),
          this.getLookups('gender'),
          this.getLookups('ethnicity'),
          this.getLookups('religion'),
          this.getLookups('marital_status'),
          this.getLookups('place_of_birth'),
        ])
      },
      getCookie (cname) {
        var name = cname + '='
        var ca = document.cookie.split(';')
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i]
          while (c.charAt(0) === ' ') {
            c = c.substring(1)
          }
          if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length)
          }
        }
        return ''
      },

      uuidv4 () {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
          return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        })
      },
    },
  }
</script>
